import { Download, Loader2 } from "lucide-react"
import { useState } from "react"
import { Thread } from "../../../types"
import { downloadPdfFromApi } from "../../utils/downloadFile"
import bbApi from "../../../api"
import BBModal from "../modal"
import { useToast } from "../../hooks"

interface Props {
  show: boolean
  thread: Thread
  onClose: () => void
}

const ExportConversationModal = ({ show, thread, onClose }: Props) => {
  const [isDownloading, setIsDownloading] = useState(false)
  const { pushErrorToast } = useToast()

  const handleDownload = async () => {
    try {
      setIsDownloading(true)

      // Make authenticated API call
      const response = await bbApi.others.downloadConversationPdf(thread._id)

      if (response && "file" in response) {
        // Generate filename
        const filename = `conversation-${thread.first_name}-${thread.last_name}.pdf`

        // Download the PDF using the file URL from API response
        const success = await downloadPdfFromApi(response, filename)

        if (success) {
          onClose()
        } else {
          console.error("Failed to download PDF")
        }
      } else {
        console.error("API Error:", response)
        if (response && "message" in response && response.message) {
          pushErrorToast(response.message)
        } else {
          pushErrorToast("Failed to export conversation")
        }
      }
    } catch (error) {
      console.error("Download error:", error)
      pushErrorToast("Failed to export conversation")
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <BBModal
      show={show}
      title="Export Conversation"
      onClose={onClose}
      size="md"
    >
      <div className="space-y-6">
        {/* Download PDF Section */}
        <div
          className="bg-gray-100 rounded-lg p-6"
          role="button"
          onClick={handleDownload}
        >
          <div className="flex items-center space-x-4 text-primary-alt-400">
            <div className="flex-shrink-0">
              {isDownloading ? (
                <Loader2 className="animate-spin h-6 w-6" />
              ) : (
                <Download className="h-6 w-6" />
              )}
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-medium">Download PDF</h3>
              <p className="">Save to your device</p>
            </div>
          </div>
        </div>
      </div>
    </BBModal>
  )
}

export default ExportConversationModal
